import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

export default function CheckboxRegional({ isVisible, isRegional, onChange }) {
  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="right"
      overlay={
        <Popover id="popover-is-regional">
          <Popover.Title>Caution</Popover.Title>
          <Popover.Content>
            <p>
              This is a reminder that for regional quotes the click charge must
              be greater than the Direct Pricebook MSP.
            </p>
            <p>
              The delivery address chosen must be the business partner's
              address.
            </p>
            <p>
              Finally in Salesforce the IMA form must be completed and attached
              to the opportunity.
            </p>
          </Popover.Content>
        </Popover>
      }
    >
      <input
        style={{
          visibility: isVisible ? "visible" : "hidden"
        }}
        type="checkbox"
        checked={isRegional}
        onChange={e => onChange(e.target.checked)}
      />
    </OverlayTrigger>
  );
}
